'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { FallbackProps } from 'react-error-boundary';
import { DiagnosticErrorFallback } from './DiagnosticErrorFallback';
export type ErrorFallbackProps = FallbackProps & {
  link?: string;
  componentStack?: string | null;
};

/**
 * Default react-error-boundary fallback with unified diagnostics.
 */
export function ErrorFallback(t0) {
  const $ = _c(4);
  const {
    error,
    resetErrorBoundary,
    componentStack
  } = t0;
  let t1;
  if ($[0] !== componentStack || $[1] !== error || $[2] !== resetErrorBoundary) {
    t1 = <DiagnosticErrorFallback error={error} reset={resetErrorBoundary} source="ErrorBoundary" layout="embedded" componentStack={componentStack} />;
    $[0] = componentStack;
    $[1] = error;
    $[2] = resetErrorBoundary;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}